import 'jquery'
import './lib/picker.date.js'
import './lib/translations/ca_ES'
